export const dineoutRestaurants = [{
    "info": {
        "id": "283074",
        "name": "TEO - Lounge & Bar",
        "rating": {
            "value": "4.2",
            "count": 5861,
            "countDescription": "5K+ Google ratings"
        },
        "costForTwo": "₹2200 for two",
        "cuisines": ["Chinese", "North Indian"],
        "locality": "Punjabi Bagh",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-04-06T12:34:20.380",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/4/6/bc4262d0-d54f-460c-97ab-1330129fadf3_image0feab5d2335f54f159a70ed5a663862aa.JPG"
        }],
        "highlights": ["Alcohol served", "Parking available", "Valet parking", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "7.3 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Punjabi Bagh, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 40% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "40% Off",
                "subtitle": "on total bill",
                "description": "FLAT 40% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 40
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "40% OFF",
                "description": "FLAT 40% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 40
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 2,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "promoted": true,
        "adTrackingId": "cid=f73f9693-e55a-4741-8fc0-182ae8346730~~adtrid=959b3ff1-2d4b-42f8-b0e3-cf028bdbf4f2~~adgrpid=f73f9693-e55a-4741-8fc0-182ae8346730#ag1~~cndid=283074~~bp=BT+QKy1rkT+ml0BBjrCRQ/YJNiodMUT2WjuYH9mOfqKVV9AguNHDRX4pDFxN9nItGVBYtIwXH6KxVaBroysPdr2Y4TgZ~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1752563938147~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=218~~kw=~~cityid=4~~lmd=4653.1553~~collid=116084",
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 40% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 2 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/283074/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "137204",
        "name": "CUE- Culinary Urban Experience",
        "rating": {
            "value": "4.0",
            "count": 661,
            "countDescription": "661 Google ratings"
        },
        "costForTwo": "₹1300 for two",
        "cuisines": ["Chinese", "North Indian"],
        "locality": "Rohini",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2022-08-23T03:51:15.689",
            "name": "ambience",
            "url": "v1661226678/vw0zrmp9gfallu8eklfo.jpg"
        }],
        "highlights": ["Parking available", "Smoking area", "SwiggyPay accepted", "Pure veg"],
        "locationInfo": {
            "distanceString": "1.9 km",
            "landmarkName": "Manglam Paradise Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Manglam Paradise Mall, Rohini, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 40% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "30% Off",
                "subtitle": "on total bill",
                "description": "FLAT 30% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 30
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "40% OFF",
                "description": "FLAT 40% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 40
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 3,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }, {
                "logoCtx": {
                    "text": "Free Dessert",
                    "logo": "dineout/free_desert.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 40% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 3 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vegClassifier": "VEG_CLASSIFIER_VEG",
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }, {
            "logo": {
                "logo": "dineout/free_desert.png"
            },
            "title": "Free Dessert",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/137204/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "821686",
        "name": "Zoca Diner",
        "rating": {
            "value": "4.3",
            "count": 277,
            "countDescription": "277 Google ratings"
        },
        "costForTwo": "₹1400 for two",
        "cuisines": ["Chinese", "North Indian"],
        "locality": "Rohini",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-09-02T13:40:19.996",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/9/2/4b63b414-156c-43e0-8944-2cc912a60813_Screenshot20240902190650ca4e5ef38da24f66b119513d35ca5658.PNG"
        }],
        "highlights": ["Reservation available", "Parking available", "Free wifi", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "2.2 km",
            "landmarkName": "Unity One Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Unity One Mall, Rohini, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 20% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "10% Off",
                "subtitle": "on total bill",
                "description": "FLAT 10% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "20% OFF",
                "description": "FLAT 20% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 20
                }
            }],
            "infos": [{
                "header": "Get extra 10% off using TRYNEW",
                "description": " 10% off with TRYNEW + Up to 10% bank offers",
                "coupon": {
                    "code": "TRYNEW"
                },
                "otherLogoContext": {
                    "logo": "OFFER_LOGO"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "offerCount": 3,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 20% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 3 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            },
            "couponOffer": {
                "title": "Get extra 10% off using TRYNEW",
                "style": {
                    "textColour": "primary_accent"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/821686/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "372603",
        "name": "The Dine Room",
        "rating": {
            "value": "4.6",
            "count": 2623,
            "countDescription": "2K+ Google ratings"
        },
        "costForTwo": "₹1600 for two",
        "cuisines": ["Chinese", "North Indian"],
        "locality": "Punjabi Bagh",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-09-11T12:41:15.152",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/9/11/9c9594f1-c49e-4e04-8b60-bfcfe0fa0580_f8903ea36755c1ac946f66ece6880632520770082fb248619913560ec8fe795a.JPG"
        }],
        "highlights": ["Alcohol served", "Parking available", "Valet parking", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "7.3 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Punjabi Bagh, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 50% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "40% Off",
                "subtitle": "on total bill",
                "description": "FLAT 40% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 40
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "50% OFF",
                "description": "FLAT 50% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 50
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 3,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "promoted": true,
        "adTrackingId": "cid=0f366c0c-3789-488e-8dd4-40612f7c63fe~~adtrid=c7d90954-e1b7-4a5a-b22f-9ef7f1ae5ff9~~adgrpid=0f366c0c-3789-488e-8dd4-40612f7c63fe#ag1~~cndid=372603~~bp=6bk4RSI54/gAAByY6u91mULMZXUOISnT2GKcbu3FZh7eDZjQlD4SeiobMpWYpCINppswecoyY54m6OcJs6/Sbw9uLSGG~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1752563938147~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=218~~kw=~~cityid=4~~lmd=4650.576~~collid=116084",
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 50% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 3 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/372603/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "345700",
        "name": "Spice Art - Crowne Plaza",
        "rating": {
            "value": "4.4",
            "count": 955,
            "countDescription": "955 Google ratings"
        },
        "costForTwo": "₹3500 for two",
        "cuisines": ["Mughlai", "North Indian"],
        "locality": "Rohini",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-01-15T21:00:12.845",
            "name": "ambience",
            "url": "v1673816414/1c41eee29677d84b5c570e82edd4cbd6.jpg"
        }],
        "highlights": ["Parking available", "Valet parking", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "2.4 km",
            "landmarkName": "Crowne Plaza",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Crowne Plaza, Rohini, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 25% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "15% Off",
                "subtitle": "on total bill",
                "description": "FLAT 15% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "25% OFF",
                "description": "FLAT 25% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 25
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 2,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 25% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 2 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/345700/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "307466",
        "name": "Mosaic - Crowne Plaza Rohini",
        "rating": {
            "value": "4.4",
            "count": 1276,
            "countDescription": "1K+ Google ratings"
        },
        "costForTwo": "₹3000 for two",
        "cuisines": ["Chinese", "Continental"],
        "locality": "Rohini",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-01-15T21:00:14.125",
            "name": "ambience",
            "url": "v1673816415/c107452669db828a6a32b97383de4804.jpg"
        }],
        "highlights": ["Parking available", "Valet parking", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "2.3 km",
            "landmarkName": "Crowne Plaza",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Crowne Plaza, Rohini, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 25% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "15% Off",
                "subtitle": "on total bill",
                "description": "FLAT 15% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "25% OFF",
                "description": "FLAT 25% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 25
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 2,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 25% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 2 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/307466/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "10391",
        "name": "Lotus Leaf",
        "rating": {
            "value": "4.2",
            "count": 992,
            "countDescription": "992 Google ratings"
        },
        "costForTwo": "₹2300 for two",
        "cuisines": ["Continental", "North Indian"],
        "locality": "Prashant Vihar",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-12-15T06:00:52.846",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/12/15/714d7396-bc5f-48a4-8a80-7b9d50fe0164_image7ac4df19b8a9745779eed2b1a3439623a.JPG"
        }],
        "highlights": ["Alcohol served", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "4.5 km",
            "landmarkName": "Fun City Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Fun City Mall, Prashant Vihar, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 20% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "10% Off",
                "subtitle": "on total bill",
                "description": "FLAT 10% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "20% OFF",
                "description": "FLAT 20% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 20
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 2,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "promoted": true,
        "adTrackingId": "cid=08d5dfe5-9374-426f-89e2-6a14d6bcca04~~adtrid=8862e4ba-e83b-4d60-b66d-5201dde7b249~~adgrpid=08d5dfe5-9374-426f-89e2-6a14d6bcca04#ag1~~cndid=10391~~bp=RENohAl26QIfKSlAw9VbAGLjqyNLZBPSZSfMcw45glvVhT3tn88mHhXiOHxv6WLESctHSi0ZoLrSDoS2d8/0muTL6Iqc~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1752563938147~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=218~~kw=~~cityid=4~~lmd=3356.041~~collid=116084",
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 20% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 2 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/10391/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "21552",
        "name": "Metro Grill",
        "rating": {
            "value": "4.1",
            "count": 1829,
            "countDescription": "1K+ Google ratings"
        },
        "costForTwo": "₹1500 for two",
        "cuisines": ["North Indian", "Chinese"],
        "locality": "Rohini",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2025-02-20T07:33:21.335",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/2/20/dda2874d-be1a-42d9-86c1-9ea7a83afa8c_image287e6180abf6a45029e8c3cfabe3c58f2.JPG"
        }],
        "highlights": ["Alcohol served", "Parking available", "Free wifi", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "2.2 km",
            "landmarkName": "City Centre Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "City Centre Mall, Rohini, Delhi"
        },
        "offerInfoV2": {
            "vendorOffer": {
                "header": "FLAT 25% OFF",
                "offerLogo": {}
            },
            "customerOffer": {
                "header": "+Up to 10% off with HDFC Bank Credit Card",
                "offerLogo": {}
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "25% Off",
                "subtitle": "on total bill",
                "description": "FLAT 25% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 25
                }
            },
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 25% off",
                "subtitle": "on walk-in",
                "subtext": "+ 1 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/21552/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "815465",
        "name": "Cafe Bistro 57",
        "rating": {
            "value": "4.7",
            "count": 2733,
            "countDescription": "2K+ Google ratings"
        },
        "costForTwo": "₹900 for two",
        "cuisines": ["Chinese", "North Indian"],
        "locality": "Rohini",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-01-09T10:08:45.180",
            "name": "WhatsApp-Image-2024-01-04-at-17 452 jpg",
            "url": "v1704794926/ee74e3c9cb7642ffc44f89051fd9148a.jpg"
        }],
        "highlights": ["Reservation available", "Parking available", "Free wifi", "SwiggyPay accepted", "Pure veg"],
        "locationInfo": {
            "distanceString": "2.9 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Rohini, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 30% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "15% Off",
                "subtitle": "on total bill",
                "description": "FLAT 15% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "30% OFF",
                "description": "FLAT 30% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 30
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 30% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vegClassifier": "VEG_CLASSIFIER_VEG",
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/815465/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "719877",
        "name": "The Dom Lounge Dine and Bar",
        "rating": {
            "value": "4.4",
            "count": 1540,
            "countDescription": "1K+ Google ratings"
        },
        "costForTwo": "₹2000 for two",
        "cuisines": ["Italian", "North Indian"],
        "locality": "Punjabi Bagh",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-01-16T12:21:48.147",
            "url": "v1705407709/9d1a0eb3c75b3282e97304041ecf66cb.jpg"
        }],
        "highlights": ["Parking available", "Valet parking", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "7.5 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Punjabi Bagh, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 40% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "25% Off",
                "subtitle": "on total bill",
                "description": "FLAT 25% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 25
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "40% OFF",
                "description": "FLAT 40% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 40
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "promoted": true,
        "adTrackingId": "cid=256ac7c5-c31b-462e-ae41-459c8feff0cb~~adtrid=69035433-c507-4532-b1f8-1055fabe07fe~~adgrpid=256ac7c5-c31b-462e-ae41-459c8feff0cb#ag1~~cndid=719877~~bp=wstccNXRtnxRVKgpncXbBcfg7mhC+GmQgpv0VRSI3ZdREQusZVUB9S2zMLXMFYrghFnupOCDTgOMOi3Xevmi4v/etslj~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1752563938147~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=218~~kw=~~cityid=4~~lmd=4787.994~~collid=116084",
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 40% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "mediaStyle": {
            "aspectRatio": 1.7778
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/719877/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
},
{
    "info": {
        "id": "720462",
        "name": "Cafe West Delhi",
        "rating": {
            "value": "4.1",
            "count": 146,
            "countDescription": "146 Google ratings"
        },
        "costForTwo": "₹1300 for two",
        "cuisines": ["North Indian", "Pizza"],
        "locality": "Hari Nagar",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-06-01T13:13:17.082",
            "url": "v1685625198/8396c36df3177723f2f862bf35bd9477.webp"
        }],
        "highlights": ["Parking available", "Free wifi", "Pet friendly", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "9.9 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Hari Nagar, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 30% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "10% Off",
                "subtitle": "on total bill",
                "description": "FLAT 10% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "30% OFF",
                "description": "FLAT 30% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 30
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "promoted": true,
        "adTrackingId": "cid=d6c47adc-a68b-43e1-adc6-fdb1f4090e4d~~adtrid=34c77013-9ec6-4e16-a27b-c372fac19e1a~~adgrpid=d6c47adc-a68b-43e1-adc6-fdb1f4090e4d#ag1~~cndid=720462~~bp=CeZXXvL6WwMAgDl4n3xRzKW1J0xiiOnpp2uFzGyuNdxKtXdq5HsYYINn6+Y05X4RzCtIKrR2AtqsGkkd40KiALJBF0zI~~mp=SWIGGY_IN~~bl=DINEOUT~~st=~~srvts=1752563938081~~plid=6063bb22-c5fd-4da9-ad5a-97d86b61ddf4~~plpr=DINEOUT_COLLECTION#LISTING~~zoneid=218~~kw=~~cityid=4~~lmd=7999.6763~~collid=116082",
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 30% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/720462/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "601182",
        "name": "Tim Hortons",
        "rating": {
            "value": "4.6",
            "count": 1246,
            "countDescription": "1K+ Google ratings"
        },
        "costForTwo": "₹800 for two",
        "cuisines": ["Beverages", "Fast Food"],
        "locality": "Punjabi Bagh",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-01-03T10:06:53.683",
            "url": "v1682317457/ea4a26733fdc06e8517ca7d15508c35c.jpg"
        }],
        "highlights": ["Parking available", "Free wifi", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "7.1 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Punjabi Bagh, Delhi"
        },
        "offerInfoV2": {
            "vendorOffer": {
                "header": "FLAT 30% OFF",
                "offerLogo": {}
            },
            "customerOffer": {
                "header": "+Up to 10% off with HDFC Bank Credit Card",
                "offerLogo": {}
            },
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 25% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "30% Off",
                "subtitle": "on total bill",
                "description": "FLAT 30% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 30
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "25% OFF",
                "description": "FLAT 25% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 25
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 2,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 30% off",
                "subtitle": "on walk-in",
                "subtext": "+ 2 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/601182/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "7859",
        "name": "Wok In The Clouds",
        "rating": {
            "value": "4.1",
            "count": 772,
            "countDescription": "772 Google ratings"
        },
        "costForTwo": "₹1000 for two",
        "cuisines": ["Chinese", "Thai"],
        "locality": "Punjabi Bagh",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2022-08-18T20:30:54.923",
            "name": "ambience",
            "url": "v1660854657/qbujbg0bttygdargxgvp.jpg"
        }],
        "highlights": ["Alcohol served", "Parking available", "Valet parking", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "7.7 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Punjabi Bagh, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 30% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "15% Off",
                "subtitle": "on total bill",
                "description": "FLAT 15% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "30% OFF",
                "description": "FLAT 30% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 30
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 30% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/7859/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "441917",
        "name": "Suravie Live it Up",
        "rating": {
            "value": "4.1",
            "count": 388,
            "countDescription": "388 Google ratings"
        },
        "costForTwo": "₹1100 for two",
        "cuisines": ["Chinese", "North Indian"],
        "locality": "Netaji Subhash Place",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2025-03-12T07:33:06.909",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2025/3/12/e6f24ac4-5c1e-4b1d-8746-d6164657e729_image71d74cdd93e304262a68302c97017f12a.JPG"
        }],
        "highlights": ["Alcohol served", "Parking available", "Valet parking", "Free wifi", "SwiggyPay accepted", "Pure veg"],
        "locationInfo": {
            "distanceString": "6.2 km",
            "landmarkName": "Pacific Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Pacific Mall, Netaji Subhash Place, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 50% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "15% Off",
                "subtitle": "on total bill",
                "description": "FLAT 15% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "50% OFF",
                "description": "FLAT 50% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 50
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 3,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 50% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 3 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vegClassifier": "VEG_CLASSIFIER_VEG",
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/441917/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "5682",
        "name": "Berco's - If You Love Chinese",
        "rating": {
            "value": "4.1",
            "count": 1027,
            "countDescription": "1K+ Google ratings"
        },
        "costForTwo": "₹1300 for two",
        "cuisines": ["Chinese", "Thai"],
        "locality": "Rajouri Garden",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-07-14T10:47:06.995",
            "url": "v1689331628/51ded6fe7bf4f248a73e2edbdf1407d0.jpg"
        }],
        "highlights": ["Parking available", "Free wifi", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "8.9 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Rajouri Garden, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 20% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "10% Off",
                "subtitle": "on total bill",
                "description": "FLAT 10% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "20% OFF",
                "description": "FLAT 20% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 20
                }
            }],
            "infos": [{
                "header": "Get extra 10% off using TRYNEW",
                "description": " 10% off with TRYNEW + Up to 10% bank offers",
                "coupon": {
                    "code": "TRYNEW"
                },
                "otherLogoContext": {
                    "logo": "OFFER_LOGO"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }, {
                "logoCtx": {
                    "text": "Free Dessert",
                    "logo": "dineout/free_desert.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 20% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            },
            "couponOffer": {
                "title": "Get extra 10% off using TRYNEW",
                "style": {
                    "textColour": "primary_accent"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }, {
            "logo": {
                "logo": "dineout/free_desert.png"
            },
            "title": "Free Dessert",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/5682/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "731499",
        "name": "China Bistro",
        "rating": {
            "value": "4.6",
            "count": 166,
            "countDescription": "166 Google ratings"
        },
        "costForTwo": "₹1800 for two",
        "cuisines": ["Japanese", "Korean"],
        "locality": "Saket",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-06-26T15:25:46.042",
            "url": "v1687793147/3588b9a009307b3c277af6910625033a.jpg"
        }],
        "highlights": ["SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "28.3 km",
            "landmarkName": "Select Citywalk Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Select Citywalk Mall, Saket, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 20% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "20% OFF",
                "description": "FLAT 20% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 20
                }
            }],
            "infos": [{
                "header": "Get extra 10% off using SAVE150UPI",
                "description": " 10% off with SAVE150UPI + Up to 10% bank offers",
                "coupon": {
                    "code": "SAVE150UPI"
                },
                "otherLogoContext": {
                    "logo": "OFFER_LOGO"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "offerCount": 3,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 20% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 3 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            },
            "couponOffer": {
                "title": "Get extra 10% off using SAVE150UPI",
                "style": {
                    "textColour": "primary_accent"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/731499/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "720752",
        "name": "Pincode",
        "rating": {
            "value": "3.4",
            "count": 265,
            "countDescription": "265 Google ratings"
        },
        "costForTwo": "₹2000 for two",
        "cuisines": ["Modern Indian", "Mughlai"],
        "locality": "Saket",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-06-23T08:29:15.003",
            "url": "v1689165482/c1c47f053f99b38032705ab5e0f6d2c6.jpg"
        }],
        "highlights": ["Parking available", "Free wifi", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "28.4 km",
            "landmarkName": "Select Citywalk Mall",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Select Citywalk Mall, Saket, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 15% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "15% OFF",
                "description": "FLAT 15% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 15% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 1 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/720752/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "22702",
        "name": "Berco's - If You Love Chinese",
        "rating": {
            "value": "4.0",
            "count": 975,
            "countDescription": "975 Google ratings"
        },
        "costForTwo": "₹1300 for two",
        "cuisines": ["Chinese", "Thai"],
        "locality": "East Patel Nagar",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2022-08-29T21:06:36.405",
            "name": "ambience",
            "url": "v1661807198/jaao2habfpb1u71tgecq.jpg"
        }],
        "highlights": ["SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "11.7 km",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "East Patel Nagar, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 20% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "10% Off",
                "subtitle": "on total bill",
                "description": "FLAT 10% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "20% OFF",
                "description": "FLAT 20% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 20
                }
            }],
            "infos": [{
                "header": "Get extra 10% off using TRYNEW",
                "description": " 10% off with TRYNEW + Up to 10% bank offers",
                "coupon": {
                    "code": "TRYNEW"
                },
                "otherLogoContext": {
                    "logo": "OFFER_LOGO"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }, {
                "logoCtx": {
                    "text": "Free Dessert",
                    "logo": "dineout/free_desert.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 20% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            },
            "couponOffer": {
                "title": "Get extra 10% off using TRYNEW",
                "style": {
                    "textColour": "primary_accent"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }, {
            "logo": {
                "logo": "dineout/free_desert.png"
            },
            "title": "Free Dessert",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/22702/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "5681",
        "name": "Berco's - If You Love Chinese",
        "rating": {
            "value": "4.2",
            "count": 2003,
            "countDescription": "2K+ Google ratings"
        },
        "costForTwo": "₹1300 for two",
        "cuisines": ["Chinese", "Thai"],
        "locality": "Janakpuri",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2023-07-24T09:44:32.937",
            "url": "v1690191874/bdfca065555ef8a73dac0befab649e1a.jpg"
        }],
        "highlights": ["Alcohol served", "Parking available", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "9.1 km",
            "landmarkName": "Janak Place District Centre",
            "city": {
                "name": "Delhi"
            },
            "formattedAddress": "Janak Place District Centre, Janakpuri, Delhi"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 20% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "info": {
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "10% Off",
                "subtitle": "on total bill",
                "description": "FLAT 10% OFF",
                "isOfferApplicableNow": true,
                "tnc": ["Discount on this restaurant is applicable throughout the day for you.", "You can claim this discount on any bill amount. You can pay up to Rs. 3,00,000 per transaction via Swiggy Dineout at a restaurant.", "You get a flat discount on your bill amount with no upper limit.", "This offer cannot be clubbed with an in-house offer or offers from other platforms", "The offer's availability on National/Public Holidays is as per the restaurant's discretion", "The restaurant may levy Service charge/Entry fees as per its discretion", "The discount may not be applicable on Combos, Meal, Beverages, MRP Products, Beer Buckets, Bottled Drinks, Hookah/Seesha, Discounted platters/Thalis, Buffets, as per Catch items and special menus' as per the restaurant's discretion.", "Any items ordered that are not included in the offer will be billed separately.", "Menu prices and items may change without prior notice.", "Weekend and weekdays offer might differ as per restaurant’s discretion."],
                "offerType": "OFFER_TYPE_V2_REGULAR",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            },
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "20% OFF",
                "description": "FLAT 20% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 20
                }
            }],
            "infos": [{
                "header": "Get extra 10% off using TRYNEW",
                "description": " 10% off with TRYNEW + Up to 10% bank offers",
                "coupon": {
                    "code": "TRYNEW"
                },
                "otherLogoContext": {
                    "logo": "OFFER_LOGO"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }, {
                "logoCtx": {
                    "text": "Free Dessert",
                    "logo": "dineout/free_desert.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 20% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            },
            "couponOffer": {
                "title": "Get extra 10% off using TRYNEW",
                "style": {
                    "textColour": "primary_accent"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }, {
            "logo": {
                "logo": "dineout/free_desert.png"
            },
            "title": "Free Dessert",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/5681/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}, {
    "info": {
        "id": "963357",
        "name": "TGH - Bar & Terrace Dining",
        "rating": {
            "value": "4.2",
            "count": 5656,
            "countDescription": "5K+ Google ratings"
        },
        "costForTwo": "₹1900 for two",
        "cuisines": ["North Indian", "Mediterranean"],
        "locality": "Sector 4",
        "mediaFiles": [{
            "type": "IMAGE",
            "id": "2024-09-26T09:37:12.469",
            "url": "DINEOUT_ALL_RESTAURANTS/IMAGES/RESTAURANT_IMAGE_SERVICE/2024/9/26/7af1c834-9351-48d9-aeab-0ae0979ed5c1_image317ff8cd198d144c2bab0f0ba4b10436af.JPG"
        }],
        "highlights": ["Alcohol served", "Reservation available", "Parking available", "Smoking area", "SwiggyPay accepted"],
        "locationInfo": {
            "distanceString": "40.7 km",
            "landmarkName": "Galaxy Blue Sapphire Plaza",
            "city": {
                "name": "Noida"
            },
            "formattedAddress": "Galaxy Blue Sapphire Plaza, Sector 4, Noida"
        },
        "offerInfoV2": {
            "otherOffers": {
                "logo": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "offers": [{
                    "header": "FLAT 40% OFF",
                    "offerLogo": {},
                    "availability": "STACKED_WIDGET_AVAILABILITY_AVAILABLE_TODAY",
                    "dealCategory": "Pre-Book",
                    "availabilityDescription": "Available today"
                }]
            }
        },
        "vendorOffer": {
            "otherOffersInfo": [{
                "header": "TODAY’S \nDISCOUNT",
                "type": "FLAT",
                "title": "40% OFF",
                "description": "FLAT 40% OFF",
                "isOfferApplicableNow": true,
                "offerType": "OFFER_TYPE_V2_PRE_BOOK",
                "availability": "OFFER_AVAILABILITY_AVAILABLE_TODAY",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/dineout/preOffer.png"
                },
                "dealCategory": "Pre-Book",
                "availabilityDescription": "Available today",
                "offersLogoV2": [{
                    "logo": "dineout/rx-card/OFFER.png",
                    "type": "LOGO_TYPE_RX_TILE"
                }, {
                    "logo": "dineout/search/as/Offers.png",
                    "type": "LOGO_TYPE_SEARCH_SUGGESTION"
                }, {
                    "type": "LOGO_TYPE_PAY_BILL"
                }],
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 40
                }
            }],
            "infos": [{
                "description": "Up to 10% off with HDFC Bank Credit Card",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 4,
            "offerHighlights": [{
                "logoCtx": {
                    "text": "Table booking",
                    "logo": "dineout/rx-card/highlights/book.png"
                }
            }]
        },
        "customerOffer": {
            "info": {
                "description": "+ Up to 10% bank offers",
                "otherLogoContext": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1679057464/portal/m/dineout/offer_icon_1.png"
                },
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            },
            "loyaltyInfo": {
                "cta": {},
                "offerDetail": {
                    "type": "FLAT",
                    "title": "₹150 Off",
                    "subtitle": "above ₹1500",
                    "description": " ₹150 off",
                    "logoContext": {
                        "text": "with",
                        "logo": "ONE"
                    },
                    "coupon": {
                        "availableCouponCount": 2
                    },
                    "otherLogoContext": {
                        "logo": "OFFER_LOGO"
                    },
                    "discountInfo": {
                        "discountType": "DISCOUNT_TYPE_FLAT",
                        "discountValue": 150
                    }
                },
                "oneBenefit": {
                    "logo": "https://dineout-media-assets.swiggy.com/swiggy/image/upload/v1669906275/dineout/one_benefits.png"
                }
            },
            "otherOffersInfo": [{
                "header": "ADDITIONAL OFFERS",
                "type": "CASHBACK",
                "title": "10%*",
                "logoContext": {},
                "tnc": ["Valid only on Swiggy HDFC Bank Credit Card", "Applicable on a minimum net transaction value of ₹100", "Monthly cashback limit of ₹1500 on Swiggy spends", "Cashback will be processed in the next statement cycle", "Other T&Cs may apply"],
                "coupon": {},
                "adjoiningSubtext": "Above ₹100",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 10
                }
            }],
            "infos": [{
                "description": "Up to 10% off with bank offers",
                "discountInfo": {
                    "discountType": "DISCOUNT_TYPE_PERCENTAGE",
                    "discountValue": 15
                }
            }],
            "offerCount": 1
        },
        "isPaymentAccepted": true,
        "offerInfoV3": {
            "offerLogo": {
                "logo": "dineout/rx-card/OFFER.png"
            },
            "vendorOffer": {
                "title": "Flat 40% off",
                "subtitle": "on pre-booking",
                "subtext": "+ 4 more",
                "style": {
                    "textColour": "text_color_highest_emphasis_inverse",
                    "bgColour": "positive"
                },
                "subtextStyle": {}
            }
        },
        "vendorHighlights": [{
            "logo": {
                "logo": "dineout/rx-card/highlights/book.png"
            },
            "title": "Table booking",
            "style": {
                "textColour": "text_color_med_emphasis",
                "bgColour": "background_button_tertiary_low"
            }
        }]
    },
    "cta": {
        "link": "https://www.swiggy.com/restaurants/963357/dineout",
        "text": "DINERSONE_REST_DETAIL",
        "type": "DEEPLINK"
    }
}
]

